
import React, { useState } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { City } from '../../data/types/city-types';
import { useIsMobile } from '@/hooks/use-mobile';
import CityInfoContent from './CityInfoContent';

interface CityHoverCardProps {
  city: City;
  children: React.ReactNode;
  onCitySelect?: (cityId: string) => void;
}

const CityHoverCard: React.FC<CityHoverCardProps> = ({ city, children, onCitySelect }) => {
  const { isMobile } = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);
  
  const handleClick = () => {
    if (isMobile) {
      setIsOpen(!isOpen);
    }
    if (onCitySelect) {
      const cityId = city.city_id || city.id;
      if (cityId) {
        onCitySelect(cityId);
      }
    }
  };

  return (
    <HoverCard open={isMobile ? isOpen : undefined}>
      <HoverCardTrigger asChild>
        <button 
          className="text-left hover:text-[#1EAEDB] transition-colors focus:outline-none focus:ring-2 focus:ring-[#1EAEDB] focus:ring-opacity-50 rounded"
          onClick={handleClick}
          aria-label={`Select ${city.name}`}
        >
          {children}
        </button>
      </HoverCardTrigger>
      <HoverCardContent 
        className="w-72 p-4 shadow-lg bg-white/95 backdrop-blur-sm border border-[#1EAEDB]/20"
        side={isMobile ? "bottom" : "right"}
        align={isMobile ? "center" : "start"}
        sideOffset={isMobile ? 2 : 5}
      >
        <CityInfoContent city={city} />
      </HoverCardContent>
    </HoverCard>
  );
};

export default CityHoverCard;
